(function () {
  const instances = new WeakMap();
  const ingredientData = [
    ["01 / 05", "Cool signal", "Menthol", "A clean, crystalline sensory edge.", "0% 58%"],
    ["02 / 05", "Sharp signal", "Camphor", "A defined, immediate aromatic note.", "25% 58%"],
    ["03 / 05", "Clear signal", "Eucalyptus", "A fresh botanical character with a clean profile.", "50% 58%"],
    ["04 / 05", "Grounded signal", "Vetiver", "A deep, dry root note with lasting presence.", "74% 58%"],
    ["05 / 05", "State-specific signal", "Botanical oils", "Each aromatic profile is blended for a distinct state cue.", "100% 58%"],
  ];
  const osAccess = {
    web: ["Browser-ready. No install.", "Open State OS on mobile or desktop and begin."],
    app: ["One tap from the ritual.", "Now on the App Store and Google Play. Keep every state within reach."],
  };

  function openThemeCartTray() {
    const tray = document.querySelector(".js-mini-cart");
    if (!tray) return false;
    tray.classList.add("active");
    document.body.classList.add("overflow-hidden");
    return true;
  }

  function refreshThemeCart() {
    const miniCart = window.theme && window.theme.miniCart;
    if (miniCart) {
      if (typeof miniCart.generateCart === "function") miniCart.generateCart();
      if (typeof miniCart.updateElements === "function") miniCart.updateElements();
    }
    window.setTimeout(() => {
      if (!openThemeCartTray()) window.location.assign("/cart");
    }, 80);
  }

  function showCartError(message) {
    const alertApi = window.theme && window.theme.alert;
    if (alertApi && typeof alertApi.new === "function") {
      alertApi.new("", message, 3000, "warning");
      return;
    }
    window.alert(message);
  }

  async function addVariantToCart(button) {
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.disabled) return;
    const label = button.dataset.defaultLabel || button.textContent.trim();
    button.disabled = true;
    button.classList.add("is-loading");
    button.setAttribute("aria-busy", "true");
    button.childNodes[0].textContent = "Adding… ";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || "Unable to add this item to the cart.");
      refreshThemeCart();
      document.dispatchEvent(new CustomEvent("whiff:cart:add", { detail: { item: result } }));
    } catch (error) {
      showCartError(error.message || "Unable to add this item to the cart.");
    } finally {
      button.disabled = false;
      button.classList.remove("is-loading");
      button.removeAttribute("aria-busy");
      button.childNodes[0].textContent = label + " ";
    }
  }

  function setCarousel(root, carousel, index) {
    const items = Array.from(carousel.querySelectorAll("[data-carousel-item]"));
    const dots = Array.from(carousel.querySelectorAll("[data-carousel-dot]"));
    if (!items.length) return;
    const active = (index + items.length) % items.length;
    carousel.dataset.activeIndex = String(active);
    items.forEach((item, itemIndex) => {
      const isActive = itemIndex === active;
      item.classList.toggle("positionRitualSceneActive", isActive && carousel.dataset.carousel === "ritual");
      item.classList.toggle("positionVariantSlideActive", isActive && carousel.dataset.carousel === "variants");
      item.classList.toggle("positionMomentSceneActive", isActive && carousel.dataset.carousel === "moments");
      item.setAttribute("aria-hidden", String(!isActive));
    });
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === active;
      dot.classList.toggle("positionRitualControlActive", isActive && carousel.dataset.carousel === "ritual");
      dot.classList.toggle("positionVariantDotActive", isActive && carousel.dataset.carousel === "variants");
      dot.classList.toggle("positionMomentRailActive", isActive && carousel.dataset.carousel === "moments");
      dot.setAttribute("aria-pressed", String(isActive));
    });
    const counter = carousel.querySelector("[data-carousel-counter]");
    if (counter) counter.textContent = String(active + 1).padStart(2, "0") + " / " + String(items.length).padStart(2, "0");
    const color = items[active].dataset.color;
    if (color) {
      carousel.style.setProperty(carousel.dataset.carousel === "moments" ? "--active-moment-color" : "--active-state", color);
    }
  }

  function initCarousel(root, carousel, cleanup) {
    let startX = null;
    const move = (amount) => setCarousel(root, carousel, Number(carousel.dataset.activeIndex || 0) + amount);
    const prev = carousel.querySelector("[data-carousel-prev]");
    const next = carousel.querySelector("[data-carousel-next]");
    const onPrev = () => move(-1);
    const onNext = () => move(1);
    prev?.addEventListener("click", onPrev);
    next?.addEventListener("click", onNext);
    cleanup.push(() => prev?.removeEventListener("click", onPrev), () => next?.removeEventListener("click", onNext));
    carousel.querySelectorAll("[data-carousel-dot]").forEach((dot) => {
      const onClick = () => setCarousel(root, carousel, Number(dot.dataset.index));
      dot.addEventListener("click", onClick);
      cleanup.push(() => dot.removeEventListener("click", onClick));
    });
    const stage = carousel.querySelector("[data-carousel-stage]") || carousel;
    const onDown = (event) => { startX = event.clientX; };
    const onUp = (event) => {
      if (startX === null) return;
      const distance = event.clientX - startX;
      startX = null;
      if (Math.abs(distance) >= 45) move(distance < 0 ? 1 : -1);
    };
    const onCancel = () => { startX = null; };
    stage.addEventListener("pointerdown", onDown);
    stage.addEventListener("pointerup", onUp);
    stage.addEventListener("pointercancel", onCancel);
    cleanup.push(() => stage.removeEventListener("pointerdown", onDown), () => stage.removeEventListener("pointerup", onUp), () => stage.removeEventListener("pointercancel", onCancel));
    setCarousel(root, carousel, 0);
  }

  function initInteractiveShift(root, shift, cleanup) {
    const panels = Array.from(shift.querySelectorAll("[data-shift-panel]"));
    const steps = Array.from(shift.querySelectorAll("[data-shift-step]"));
    const stage = shift.querySelector(".positionShiftStage");
    const next = shift.querySelector("[data-shift-next]");
    const reset = shift.querySelector("[data-shift-reset]");
    const previousArrow = shift.querySelector("[data-shift-previous]");
    const forwardArrow = shift.querySelector("[data-shift-forward]");
    const label = shift.querySelector("[data-shift-label]");
    const labels = ["Begin the shift", "Complete the shift", "See the ritual"];
    let active = 0;
    let pointerStart = null;

    const markInteracted = () => shift.classList.add("positionShiftInteracted");

    const setPhase = (index) => {
      active = Math.min(Math.max(index, 0), panels.length - 1);
      shift.dataset.activeIndex = String(active);
      panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === active;
        panel.classList.toggle("positionShiftPanelActive", isActive);
        panel.setAttribute("aria-hidden", String(!isActive));
      });
      steps.forEach((step, stepIndex) => {
        const isActive = stepIndex === active;
        step.classList.toggle("positionShiftStepActive", isActive);
        step.setAttribute("aria-selected", String(isActive));
      });
      if (label) label.textContent = labels[active];
      if (reset) reset.hidden = active === 0;
      if (previousArrow) previousArrow.disabled = active === 0;
      if (forwardArrow) forwardArrow.disabled = active === panels.length - 1;
    };

    const onNext = () => {
      markInteracted();
      if (active < panels.length - 1) {
        setPhase(active + 1);
        return;
      }
      root.querySelector("[id^='whiff-home-ritual-']")?.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const onReset = () => {
      markInteracted();
      setPhase(0);
    };
    const onPreviousArrow = () => {
      markInteracted();
      setPhase(active - 1);
    };
    const onForwardArrow = () => {
      markInteracted();
      setPhase(active + 1);
    };
    next?.addEventListener("click", onNext);
    reset?.addEventListener("click", onReset);
    previousArrow?.addEventListener("click", onPreviousArrow);
    forwardArrow?.addEventListener("click", onForwardArrow);
    cleanup.push(
      () => next?.removeEventListener("click", onNext),
      () => reset?.removeEventListener("click", onReset),
      () => previousArrow?.removeEventListener("click", onPreviousArrow),
      () => forwardArrow?.removeEventListener("click", onForwardArrow),
    );

    steps.forEach((step) => {
      const onClick = () => {
        markInteracted();
        setPhase(Number(step.dataset.index));
      };
      step.addEventListener("click", onClick);
      cleanup.push(() => step.removeEventListener("click", onClick));
    });

    const onPointerDown = (event) => {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      if (event.target.closest("button, a")) return;
      pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      stage?.setPointerCapture?.(event.pointerId);
      shift.classList.add("positionShiftDragging");
    };
    const endPointer = (event, cancelled = false) => {
      if (!pointerStart || pointerStart.id !== event.pointerId) return;
      const deltaX = event.clientX - pointerStart.x;
      const deltaY = event.clientY - pointerStart.y;
      pointerStart = null;
      shift.classList.remove("positionShiftDragging");
      if (cancelled || Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
      markInteracted();
      setPhase(active + (deltaX < 0 ? 1 : -1));
    };
    const onPointerUp = (event) => endPointer(event);
    const onPointerCancel = (event) => endPointer(event, true);
    stage?.addEventListener("pointerdown", onPointerDown);
    stage?.addEventListener("pointerup", onPointerUp);
    stage?.addEventListener("pointercancel", onPointerCancel);
    cleanup.push(
      () => stage?.removeEventListener("pointerdown", onPointerDown),
      () => stage?.removeEventListener("pointerup", onPointerUp),
      () => stage?.removeEventListener("pointercancel", onPointerCancel),
    );

    setPhase(0);
  }

  function init(root) {
    if (!root || instances.has(root)) return;
    const cleanup = [];
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const revealItems = Array.from(root.querySelectorAll("[data-reveal]"));
    let observer = { disconnect() {}, unobserve() {} };
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (!reduceMotion && typeof entry.target.animate === "function") {
            entry.target.animate([
              { opacity: 0.01, transform: "translateY(2.25rem)" },
              { opacity: 1, transform: "translateY(0)" },
            ], {
              duration: 820,
              easing: "cubic-bezier(0.16, 1, 0.3, 1)",
              fill: "both",
            });
          }
          entry.target.classList.add("isVisible");
          observer.unobserve(entry.target);
        });
      }, { rootMargin: "0px 0px -8%", threshold: 0.04 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add("isVisible"));
    }

    root.querySelectorAll("[data-carousel]").forEach((carousel) => initCarousel(root, carousel, cleanup));
    root.querySelectorAll("[data-interactive-shift]").forEach((shift) => initInteractiveShift(root, shift, cleanup));

    root.querySelectorAll("[data-whiff-add-to-cart]").forEach((button) => {
      const onClick = () => addVariantToCart(button);
      button.addEventListener("click", onClick);
      cleanup.push(() => button.removeEventListener("click", onClick));
    });

    root.querySelectorAll("a[href^='#']").forEach((anchor) => {
      const onClick = (event) => {
        const target = root.querySelector(anchor.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      anchor.addEventListener("click", onClick);
      cleanup.push(() => anchor.removeEventListener("click", onClick));
    });

    const osCounter = root.querySelector("[data-os-counter]");
    const osVisual = root.querySelector("[data-os-visual]");
    root.querySelectorAll("[data-os-moment]").forEach((button, index, buttons) => {
      const onClick = () => {
        buttons.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle("positionOsMomentActive", active);
          item.setAttribute("aria-selected", String(active));
        });
        if (osCounter) osCounter.textContent = String(index + 1).padStart(2, "0") + " / 04";
        if (osVisual) {
          osVisual.style.setProperty("--os-size", button.dataset.osSize);
          osVisual.style.setProperty("--os-position", button.dataset.osPosition);
          osVisual.style.setProperty("--os-mobile-size", button.dataset.osMobileSize);
          osVisual.style.setProperty("--os-mobile-position", button.dataset.osMobilePosition);
          osVisual.setAttribute("aria-label", "WHIFF State OS interface: " + button.dataset.osLabel);
        }
        if (window.matchMedia("(max-width: 767px)").matches) {
          button.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }
      };
      button.addEventListener("click", onClick);
      cleanup.push(() => button.removeEventListener("click", onClick));
    });

    root.querySelectorAll("[data-os-access]").forEach((button, index, buttons) => {
      const onClick = () => {
        const mode = button.dataset.osAccess;
        buttons.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle("positionOsAccessActive", active);
          item.setAttribute("aria-selected", String(active));
        });
        root.querySelector("[data-os-access-title]").textContent = osAccess[mode][0];
        root.querySelector("[data-os-access-copy]").textContent = osAccess[mode][1];
      };
      button.addEventListener("click", onClick);
      cleanup.push(() => button.removeEventListener("click", onClick));
    });

    root.querySelectorAll("[data-ingredient]").forEach((button) => {
      const activate = () => {
        const index = Number(button.dataset.index);
        root.querySelectorAll("[data-ingredient]").forEach((item) => {
          const active = Number(item.dataset.index) === index;
          item.classList.toggle("positionIngredientHotspotActive", active && item.closest(".positionIngredientHotspots"));
          item.classList.toggle("positionIngredientIndexActive", active && item.closest(".positionIngredientIndex"));
          item.setAttribute("aria-pressed", String(active));
        });
        const data = ingredientData[index];
        root.querySelector("[data-ingredient-number]").textContent = data[0];
        root.querySelector("[data-ingredient-signal]").textContent = data[1];
        root.querySelector("[data-ingredient-name]").textContent = data[2];
        root.querySelector("[data-ingredient-copy]").textContent = data[3];
        root.querySelector("[data-ingredient-visual]").style.setProperty("--ingredient-mobile-position", data[4]);
      };
      button.addEventListener("click", activate);
      button.addEventListener("pointerenter", activate);
      button.addEventListener("focus", activate);
      cleanup.push(() => button.removeEventListener("click", activate), () => button.removeEventListener("pointerenter", activate), () => button.removeEventListener("focus", activate));
    });

    const hero = root.querySelector("[data-hero]");
    const headerOffset = () => Number.parseFloat(getComputedStyle(root).getPropertyValue("--whiff-header-offset-px")) || 84;
    const visibleHeight = () => Math.max(window.innerHeight - headerOffset(), 1);
    const heroSteps = Array.from(root.querySelectorAll("[data-hero-step]"));
    let heroState = 0;
    let heroCycle = 0;
    const setHeroState = (state) => {
      if (!hero) return;
      heroState = state;
      hero.dataset.chamberState = String(state);
      root.style.setProperty("--hero-progress", String(state / 2));
      heroSteps.forEach((button, index) => {
        const active = index === state;
        button.classList.toggle("chamberControlActive", active);
        button.setAttribute("aria-pressed", String(active));
      });
      const heroBar = root.querySelector(".chamberProgress span");
      if (heroBar) heroBar.style.transform = "scaleX(" + ((state + 1) / 3) + ")";
    };
    heroSteps.forEach((button) => {
      const onClick = () => {
        if (!hero) return;
        setHeroState(Number(button.dataset.heroStep));
        if (heroCycle) window.clearInterval(heroCycle);
        if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          heroCycle = window.setInterval(() => setHeroState((heroState + 1) % 3), 4800);
        }
      };
      button.addEventListener("click", onClick);
      cleanup.push(() => button.removeEventListener("click", onClick));
    });
    setHeroState(0);
    if (hero && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      heroCycle = window.setInterval(() => setHeroState((heroState + 1) % 3), 4800);
      cleanup.push(() => window.clearInterval(heroCycle));
    }

    let frame = 0;
    const update = () => {
      frame = 0;
      const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
      root.style.setProperty("--page-progress", (pageHeight > 0 ? window.scrollY / pageHeight : 0).toFixed(4));
      const gap = root.querySelector("[data-gap]");
      if (gap) {
        const rect = gap.getBoundingClientRect();
        root.style.setProperty("--gap-progress", Math.min(1, Math.max(0, (visibleHeight() - rect.top + headerOffset()) / (rect.height + visibleHeight()))).toFixed(4));
      }
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    cleanup.push(() => window.removeEventListener("scroll", onScroll), () => window.removeEventListener("resize", onScroll));

    instances.set(root, { destroy() { observer.disconnect(); cleanup.forEach((fn) => fn()); if (frame) cancelAnimationFrame(frame); instances.delete(root); } });
  }

  function initAll(scope) { scope.querySelectorAll("[data-whiff-cinematic-home]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll(document), { once: true });
  else initAll(document);
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  document.addEventListener("shopify:section:unload", (event) => { const root = event.target.querySelector("[data-whiff-cinematic-home]"); instances.get(root)?.destroy(); });
})();
